import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import i18n from "@/i18n";
export const useConfigStore = defineStore("config", () => {
    const shouldShowTutorial = ref(localStorage.getItem("dontShowTutorial") !== "true");
    const shouldShowEventTutorial = ref(localStorage.getItem("dontShowEventTutorial") !== "true");
    const shouldShowTutorialAdmin = ref(localStorage.getItem("dontShowTutorialAdmin") !== "true");
    const isTutorialVisible = ref(false);
    const isEventTutorialVisible = ref(false);
    const isAdminTutorialVisible = ref(false);
    const connectionAPIOk = ref(false);
    const connectionCMSOk = ref(false);
    const connectionSSOOk = ref(false);
    const URLerrors = ref([]);
    const isPermissionErrorVisible = ref(false);
    const isCustomersErrorVisible = ref(false);
    const isTokenErrorVisible = ref(false);
    const isLoginErrorVisible = ref(false);
    const isRadioHelpDisabled = ref(localStorage.getItem("isRadioDisabled") === "true");
    const isRadioAfterImportDisabled = ref(false);
    const isNoProjectVisible = ref(false);
    const isNoProjectPageInfoVisible = ref(false);
    const shouldShowMqttDeviceMenuItem = ref(false);
    const shouldShowMqttGateMenuItem = ref(false);
    function setShouldShowTutorial(show) {
        localStorage.setItem("dontShowTutorial", JSON.stringify(!show));
        shouldShowTutorial.value = show;
    }
    function setShouldShowEventTutorial(show) {
        localStorage.setItem("dontShowEventTutorial", JSON.stringify(!show));
        shouldShowEventTutorial.value = show;
    }
    function setShouldShowTutorialAdmin(show) {
        localStorage.setItem("dontShowTutorialAdmin", JSON.stringify(!show));
        shouldShowTutorialAdmin.value = show;
    }
    function setRadioHelp(enabled) {
        isRadioHelpDisabled.value = !enabled;
        localStorage.setItem("isRadioDisabled", String(!enabled));
    }
    function clearLocalStorage(keysToKeep = []) {
        const lang = localStorage.getItem("lang");
        const showTutorial = localStorage.getItem("dontShowTutorial");
        const showEventTutorial = localStorage.getItem("dontShowEventTutorial");
        const isRadioDisabled = localStorage.getItem("isRadioDisabled");
        const showTutorialAdmin = localStorage.getItem("dontShowTutorialAdmin");
        const returnPath = localStorage.getItem("returnPath");
        const savedValues = [];
        for (const key of keysToKeep) {
            savedValues.push(localStorage.getItem(key));
        }
        localStorage.clear();
        localStorage.setItem("lang", lang ?? "");
        localStorage.setItem("isRadioDisabled", isRadioDisabled ?? "");
        localStorage.setItem("dontShowTutorial", showTutorial ?? "");
        localStorage.setItem("dontShowEventTutorial", showEventTutorial ?? "");
        localStorage.setItem("dontShowTutorialAdmin", showTutorialAdmin ?? "");
        localStorage.setItem("version", process.env.VUE_APP_VERSION ?? "");
        localStorage.setItem("returnPath", returnPath ?? "");
        for (const [index, key] of keysToKeep.entries()) {
            localStorage.setItem(key, savedValues[index] ?? "");
        }
    }
    async function checkURLs() {
        URLerrors.value = [];
        const client = axios.create();
        client.defaults.timeout = 10000;
        delete client.defaults.headers.common["Authorization"];
        delete client.defaults.headers.Pragma;
        delete client.defaults.headers.common["Cache-Control"];
        delete client.defaults.headers.common["Expires"];
        const authority = process.env.VUE_APP_AUTHORITY;
        if (!authority) {
            connectionSSOOk.value = false;
            return;
        }
        try {
            await client.get(authority);
            connectionSSOOk.value = true;
        }
        catch (err) {
            URLerrors.value = URLerrors.value.concat([
                {
                    error: { type: "SSO", link: process.env.VUE_APP_AUTHORITY }
                }
            ]);
            connectionSSOOk.value = false;
        }
    }
    function checkRadioHelp() {
        isRadioHelpDisabled.value = localStorage.getItem("isRadioDisabled") == "true";
    }
    function setNoProjectVisible(data) {
        isNoProjectVisible.value = data.noProjectVisible;
        isNoProjectPageInfoVisible.value = data.noProjectVisiblePageInfo;
    }
    async function setLang() {
        const locale = i18n.global.locale.value;
        localStorage.setItem("lang", locale);
        const storedLocale = localStorage.getItem(locale);
        let parsedLocale = null;
        if (storedLocale) {
            parsedLocale = JSON.parse(storedLocale);
        }
        const newDate = new Date();
        if (!storedLocale || storedLocale == "null" || newDate.getTime() > (parsedLocale?.expiry ?? 0)) {
            const response = await axios.get(process.env.VUE_APP_APICMS + `/lang/` + locale);
            const data = response.data;
            const now = new Date();
            const withExpiry = {
                value: data,
                expiry: now.getTime() + 86400000
            };
            i18n.global.setLocaleMessage(locale, data);
            localStorage.setItem(locale, JSON.stringify(withExpiry));
        }
        else {
            const parsed = JSON.parse(storedLocale);
            i18n.global.setLocaleMessage(locale, parsed.value);
        }
    }
    return {
        setRadioHelp,
        checkURLs,
        checkRadioHelp,
        setLang,
        setNoProjectVisible,
        clearLocalStorage,
        shouldShowTutorial,
        shouldShowEventTutorial,
        shouldShowTutorialAdmin,
        isTutorialVisible,
        isEventTutorialVisible,
        isAdminTutorialVisible,
        connectionAPIOk,
        connectionCMSOk,
        connectionSSOOk,
        URLerrors,
        isPermissionErrorVisible,
        isCustomersErrorVisible,
        isTokenErrorVisible,
        isLoginErrorVisible,
        isRadioHelpDisabled,
        isRadioAfterImportDisabled,
        isNoProjectVisible,
        isNoProjectPageInfoVisible,
        shouldShowMqttDeviceMenuItem,
        shouldShowMqttGateMenuItem,
        setShouldShowTutorialAdmin,
        setShouldShowTutorial,
        setShouldShowEventTutorial
    };
});
